module.exports = __webpack_public_path__ + "fd5a608a/img/55000000-0.026798ee.png";